var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 50,
    viewBox: "0 0 41 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13277",
    "data-name": "Grupo 13277",
    transform: "translate(-192 -443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13270",
    "data-name": "Grupo 13270",
    transform: "translate(108.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14613",
    "data-name": "Trazado 14613",
    d: "M172.966,30.131a3.085,3.085,0,0,0-.906-2.19,3.494,3.494,0,0,0,.891-2.663,3.6,3.6,0,0,0-3.627-3.147h-8.585a20.036,20.036,0,0,0,1.105-5.566c0-3.018-2.562-5.565-4.171-5.565a4.332,4.332,0,0,0-2.52.849.7.7,0,0,0-.26.543v4.718l-4.005,8.682-1.172.587a.7.7,0,0,0-.384.622V39.523a.7.7,0,0,0,.2.493,5.5,5.5,0,0,0,2.226,1.171,8.493,8.493,0,0,0,2.437.424H166.96a3.116,3.116,0,0,0,2.9-4.519,3.127,3.127,0,0,0,1.394-4.178A3.119,3.119,0,0,0,172.966,30.131Z",
    transform: "translate(259.967 500) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14614",
    "data-name": "Trazado 14614",
    d: "M10.427,224.332H3.476A3.479,3.479,0,0,0,0,227.808V238.93a3.479,3.479,0,0,0,3.476,3.476H7.646a3.479,3.479,0,0,0,3.476-3.476v-13.9A.7.7,0,0,0,10.427,224.332Z",
    transform: "translate(120.392 699.406) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14615",
    "data-name": "Trazado 14615",
    d: "M7.652,43H3.478A3.482,3.482,0,0,1,0,39.522V28.391a3.482,3.482,0,0,1,3.478-3.478h6.957a.7.7,0,0,1,.7.7v.266l.167-.085,4.007-8.68V12.391a.7.7,0,0,1,.26-.544A4.377,4.377,0,0,1,18.087,11c1.61,0,4.174,2.548,4.174,5.565a20.066,20.066,0,0,1-1.106,5.565h8.593a3.6,3.6,0,0,1,3.628,3.154,3.456,3.456,0,0,1-.889,2.656,3.11,3.11,0,0,1-.814,4.974A3.079,3.079,0,0,1,32,34.3a3.116,3.116,0,0,1-1.72,2.784,3.138,3.138,0,0,1,.25,2.091,3.2,3.2,0,0,1-3.151,2.429H14.609a9.061,9.061,0,0,1-3.683-.908A3.485,3.485,0,0,1,7.652,43ZM3.478,26.3a2.089,2.089,0,0,0-2.087,2.087v11.13a2.089,2.089,0,0,0,2.087,2.087H7.652a2.089,2.089,0,0,0,2.087-2.087.7.7,0,0,1,1.188-.492,6.592,6.592,0,0,0,3.681,1.188H27.379a1.8,1.8,0,0,0,1.793-1.338,1.72,1.72,0,0,0-.5-1.66.7.7,0,0,1,.4-1.2A1.734,1.734,0,0,0,30.609,34.3a1.711,1.711,0,0,0-.55-1.259.7.7,0,0,1,.4-1.2,1.723,1.723,0,0,0,.591-3.254A.7.7,0,0,1,31,27.381a2.078,2.078,0,0,0,.991-1.969,2.2,2.2,0,0,0-2.243-1.889H20.174a.7.7,0,0,1-.651-.943,21.62,21.62,0,0,0,1.347-6.015c0-2.279-2.02-4.174-2.783-4.174a2.933,2.933,0,0,0-1.391.377v4.493a.709.709,0,0,1-.064.292L12.458,26.6a.7.7,0,0,1-.32.33l-1.391.7a.711.711,0,0,1-.676-.029A.7.7,0,0,1,9.739,27v-.7Z",
    transform: "translate(120.392 500) rotate(180)",
    fill: "#3743aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14616",
    "data-name": "Trazado 14616",
    d: "M150.027,259.57a.7.7,0,0,1-.7-.7V246.363a.7.7,0,0,1,1.39,0v12.512A.7.7,0,0,1,150.027,259.57Z",
    transform: "translate(259.984 719.352) rotate(180)",
    fill: "#3743aa"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3782",
    "data-name": "Rect\\xE1ngulo 3782",
    width: 41,
    height: 50,
    transform: "translate(192 443)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.06941e4becc56592fe24ebc7bbcae124.svg";
export { ForwardRef as ReactComponent };